module.exports = {
  user: {
    key: 'user',
    label: 'User',
  },
  org: {
    key: 'org',
    label: 'Organization',
  },
  team: {
    key: 'team',
    label: 'Team',
  },
  eoc: {
    key: 'eoc',
    label: 'Case',
  },
};